module.exports = __webpack_public_path__ + "static/media/Gallary1.9820430b.webp";